
import { Component, Prop, Vue } from 'vue-property-decorator';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import Business from '../models/Business';
import AnOverline from '../components/AnOverline.vue';
import BusinessTestimony from './BusinessTestimony.vue';

@Component({ components: { AnOverline, BusinessTestimony, MediaImg } })
export default class extends Vue {
  @Prop(Object) readonly business?: Business;

  get hasData() {
    return (this.hasKSPText || this.hasQuoteText) && this.hasImage;
  }

  get hasKSPText() {
    return (this.business?.kspText || '').length > 0;
  }

  get hasQuoteText() {
    return (this.business?.locale.quoteText || '').length > 0;
  }

  get hasImage() {
    return this.business?.quoteImage?.id || false;
  }

  get imageId() {
    return this.business?.quoteImage?.id;
  }

  get aspectRatio() {
    return this.business?.quoteAspectRatio;
  }
}
